// @gm/components is using the NuxtLink component, but does not have it installed.
// nuxt will automatically import it for app components, but we need to register it
// globally here for ui library components to be able to resolve it.

import {NuxtLink} from '#components';

export default defineNuxtPlugin((nuxtApp): void => {
    nuxtApp.vueApp.component('NuxtLink', NuxtLink)
})
